// 薬用リップ製品データ

export const medicatedProducts = [
	{
		id: 'medicated-regular',
		name: 'DHC 薬用 リップクリーム',
		price: '770',
		tag: '医薬部外品',
		headingTag: { text: 'しっかり保湿', color: 'outline' },
		mainCopy: '唇の荒れ・乾燥を防いで<br class="d-sm-none">うるおいキープ',
		description: '薬用成分に、オリーブバージンオイル<sup>※</sup>などのトリートメント保湿成分を配合。<br>ベタつきのないナチュラルな使い心地でありながら<br>優れた保湿力をもつ薬用リップクリームです。',
		note: '※1999年2月~2025年12月末日までの総販売本数(コラボ品含む)',
		recommendations: [
			'唇のカサつき、乾燥が気になる',
			'うるおいもツヤも欲しい',
			'塗りやすいなめらかなテクスチャーが良い',
			'肌にやさしい、天然成分にこだわりたい',
			'口紅の下地代わりに使いたい'
		],
		images: {
			product: './assets/images/products/medicated/main_regular.webp',
			ingredientsPc: './assets/images/products/medicated/function_regular_pc.webp',
			ingredientsSp: './assets/images/products/medicated/function_regular_sp.webp'
		},
		ingredientsHighlight: {
			title: 'トリートメント保湿成分配合<br>唇の荒れや乾燥を防ぎ、<br class="d-sm-none">ひと塗りでうるおう唇へ',
			description: null
		},
		badges: ['無香料', '無着色', 'パラベン<br>フリー', '天然成分<br>配合'],
		badgesExtra: null,
		footer: '※ 保湿成分',
		purchaseUrl: 'https://www.dhc.co.jp/goods/13.html?gclid=EAIaIQobChMIibKbqpXUlgMVSW4PAh0pxTDlEAAYASAAEgKHLvD_BwE&gbraid=0AAAAADSIgCYpoDz3zu_ZfPkdaHlKktvb5'
	},
	{
		id: 'medicated-sensitive',
		name: 'DHC 薬用 リップクリーム<br class="d-sm-none"> センシティブ',
		price: '825',
		tag: '医薬部外品',
		headingTag: { text: '敏感肌', color: 'outline' },
		mainCopy: '「敏感くちびる」をやさしくケア<br>セラミド<sup>※</sup>配合',
		description: '大人気の「DHC薬用 リップクリーム」をベースに、<br>敏感肌用スキンケア発想で新たに処方を設計した<br class="d-none d-md-block">低刺激性の薬用リップクリームです。',
		note: '※コメヌカスフィンゴ糖脂質／保湿成分',
		recommendations: [
			'低刺激処方のリップクリームを使いたい',
			'唇のカサつき、乾燥が気になる',
			'塗りやすいなめらかなテクスチャーが良い',
			'肌にやさしい、天然成分にこだわりたい',
			'口紅の下地代わりに使いたい'
		],
		images: {
			product: './assets/images/products/medicated/main_sensitive.webp',
			ingredientsPc: './assets/images/products/medicated/function_sensitive_pc.webp',
			ingredientsSp: './assets/images/products/medicated/function_sensitive_sp.webp'
		},
		ingredientsHighlight: {
			title: '敏感肌の唇の荒れと乾燥に<br class="d-sm-none">なめらかヴェールで、唇を守る',
			description: null
		},
		badges: ['無香料', '無着色', 'パラベン<br>フリー', 'アルコール<br>フリー', '天然成分<br>配合'],
		badgesExtra: ['パッチテスト済み<sup>※2</sup>', 'アレルギーテスト済み<sup>※2</sup>'],
		footer: '※1 保湿成分<br>※2 すべての方にアレルギーや皮膚刺激が起きないというわけではありません。',
		purchaseUrl: 'https://www.dhc.co.jp/goods/23539.html'
	},
	{
		id: 'botanical',
		name: 'DHC リップクリーム ボタニカル',
		price: '770',
		tag: null,
		headingTag: { text: 'さらりと保湿', color: 'outline' },
		mainCopy: '軽やかに密着<br>15種類の植物オイル<sup>※1</sup>を配合',
		description: 'バージンオリーブオイル<sup>※2</sup>をはじめとした15種類の植物オイルを配合。<br>リップケアもスキンケアのひとつとしてとらえる<br class="d-none d-md-block">DHCのこだわりがいきたリップクリームです。',
		note: null,
		recommendations: [
			'べたつきが苦手でさらりとした使用感が好き',
			'天然・植物由来成分にこだわりたい',
			'無香料・低刺激な保湿リップクリームがほしい',
		],
		images: {
			product: './assets/images/products/medicated/main_botanical.webp',
			ingredientsPc: './assets/images/products/medicated/function_botanical_pc.webp',
			ingredientsSp: './assets/images/products/medicated/function_botanical_sp.webp'
		},
		ingredientsHighlight: {
			title: '保湿力とトリートメント効果を追求',
			description: ''
		},
		badges: ['無香料', '無着色', 'パラベン<br>フリー', 'アルコール<br>フリー', '天然成分<br>配合'],
		badgesExtra: ['パッチテスト済み<sup>※3</sup>'],
		footer: '※1 サフラワー油、コメヌカ油、ツバキ種子油、ヒマワリ種子油、メドウフォーム種子油、マカデミア種子油、アボカド油、アンズ核油、ブドウ種子油、トウモロコシ胚芽油、ホホバ種子油、スクワラン、パーム油、カニナバラ果実油、オリーブ果実油／保湿成分<br>※2 オリーブ果実油／保湿成分<br>※3 すべての方にアレルギーや皮膚刺激が起きないというわけではありません。',
		purchaseUrl: null,
		purchaseNote: '※DHCオンラインショップ・直営店でのお取り扱いはございません。'
	},
	{
		id: 'extra-moisture',
		name: 'DHC リップクリーム<br class="d-sm-none"> エクストラモイスチュア',
		price: '1,257',
		tag: null,
		headingTag: { text: 'エイジングケア※', color: 'outline' },
		mainCopy: '保湿✕エイジングケア<sup>※</sup><br>ふっくら弾むなめらかな唇へ',
		description: 'ボリュームアップ成分、植物由来成分、5種の植物エキス<sup>※1</sup>配合。<br>ハリやボリュームの低下が気になり始めた唇をリッチにうるおし、<br class="d-none d-md-block">ふっくらなめらかに整えます。',
		note: '※年齢に応じたケア',
		recommendations: [
			'唇のカサつき、乾燥が気になる',
			'縦ジワが気になる',
			'ボリュームが欲しい',
			'口紅の下地代わりに使いたい',
		],
		images: {
			product: './assets/images/products/medicated/main_moisture.webp',
			ingredientsPc: './assets/images/products/medicated/function_moisture_pc.webp',
			ingredientsSp: './assets/images/products/medicated/function_moisture_sp.webp'
		},
		ingredientsHighlight: {
			title: '“加齢によるお悩み”<br class="d-sm-none">にも対応したリップクリーム',
			description: '年齢サイン<sup>※2</sup>の気になり始めた唇のコンディションを整える、ペプチド<sup>※3</sup>配合のリップクリーム。<br>ハリを与えて、ボリューム感のある若々しい唇を演出します。<br>バージンオリーブオイル<sup>※4</sup>や甘草由来成分誘導体<sup>※5</sup>などが唇を乾燥・荒れから守り、すこやかにキープ。<br>さらに、5種の植物エキス<sup>※1</sup>がたっぷりのうるおいを与え、なめらかな唇へ導きます。'
		},
		badges: ['無香料', '無着色', 'パラベン<br>フリー', '天然成分<br>配合'],
		badgesExtra: null,
		footer: '※1 ヒメマツバボタンエキス、オタネニンジン根エキス、アロエベラ葉エキス、マグワ根皮エキス、ザクロ花エキス／保湿成分<br>※2 乾燥やハリ不足 <br>※3 パルミトイルトリペプチド－38／整肌成分<br>※4 オリーブ果実油／保湿成分<br>※5 グリチルリチン酸ステアリル／整肌成分',
		purchaseUrl: 'https://www.dhc.co.jp/goods/22430.html'
	}
];
